import styled from "styled-components";
import { responsive } from "theme/responsive";

export const BannerWrapepr = styled.section`
   background: #fcfbff;
   width: 100%;
   min-height: 100vh;
   position: relative;
   display: flex;
   gap: 3em;
   flex-direction: column;
   justify-content: center;
   align-items: center;

   ${responsive("$medium")`
   svg {
       display: none;
   }
   `}
`;
